import Pagination from '../../../../component/common/dataGrid/Pagination.jsx';
import Loading from '../../../../component/common/loading/Loading.jsx';
import MergedTableHeader from '../../../../component/common/dataGrid/MergedTableHeader.jsx';

import { useDynamicStyle } from '../../../../hooks/useDynamicStyle.js';
import '../../../../css/data-grid.css';
import * as Icons from '../../../../images/icons/icons_component.js'

const NotConnectReasonDataGrid = ({ propsInfo, state, modalOpen, setUpdateParams }) => {

    const dataList = state.dataList;
    const isSearched = state.isSearched;
    const isLoading = state.isLoading;

    const dataHead = propsInfo.dataHead;
    const dataColumn = propsInfo.dataColumn;

    const computeRowSpans = (dataList, allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });

        return rowSpans;
    };

    const cellCilck = (colIndex, item) => {
        if (colIndex === 1 || colIndex === 6) {
            const erro_seq = item.ERRO_SEQ
            const errocode = item.ERROCODE
            const bigo = item.ERROETC
            setUpdateParams(prev => ({
                ...prev,
                erro_seq: erro_seq,
                errocode: errocode,
                bigo: bigo
            }));
            modalOpen(erro_seq, errocode, bigo);
        }
    }

    const rowSpans = computeRowSpans(dataList, dataColumn);

    // Dynamic Style Hook
    const { lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();

    return (
        <>
            {isLoading ? <Loading /> :
                <div className='data_grid_container'>
                    <div className='flex flex-col w-full h-full'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`}/>
                        <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {isSearched ? <Icons.EmptyDalgu /> : <Icons.NullDalgu />}
                                                    {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        dataList.map((item, rowIndex) => {
                                            const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                            return (
                                            <tr key={rowIndex} className={gridColor}>
                                                {dataColumn.map((col, colIndex) => {
                                                    const span = rowSpans[rowIndex][col];
                                                    if (span) {
                                                        return (
                                                            <td key={colIndex} rowSpan={span} onClick={() => cellCilck(colIndex, item)}
                                                                className={(colIndex === 1 || colIndex === 6 ? hoverLightFontColor + ' hover-line-color ' : '') + (colIndex === 6 && item.ERRONAME === '입력' ? 'bg_st_row' : '')}>
                                                                {item[col]}
                                                            </td>
                                                        );
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                            </tr>
                                        )})
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray'/>
                    </div>
                </div>
            }
        </>
    );
};

export default NotConnectReasonDataGrid;